import type {GetNutshellMarketingStats_nutshellMarketingStats as NutshellMarketingStats} from 'nutshell-graphql-types';

export type EmailStats = {
    emailsSent: number;
    maxEmails: number | null | undefined;
    remainingEmails: number | null | undefined;
};

export function getEmailStats(
    nutshellMarketingStats?: NutshellMarketingStats | null
): EmailStats | null | undefined {
    if (!nutshellMarketingStats) return null;

    const numberOfEmailsSentThisMonth =
        nutshellMarketingStats.usageStats.numberOfEmailsSentThisMonth;
    const maxNumberOfEmailsPerMonth = nutshellMarketingStats.gate.maxNumberOfEmailsPerMonth;
    const remainingEmails =
        maxNumberOfEmailsPerMonth && maxNumberOfEmailsPerMonth - numberOfEmailsSentThisMonth;

    return {
        emailsSent: numberOfEmailsSentThisMonth,
        maxEmails: maxNumberOfEmailsPerMonth,
        remainingEmails,
    };
}
